import { Fragment } from 'react';

import useClubNonAthleteRoster from './UseClubNonAthleteRoster';

import ClubNonAthleteRosterFormGrid from './ClubNonAthleteRosterFormGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import { LOADING_MSG, SAVING_MSG } from '@usas/ui-web/utils/Constants';

const ClubNonAthleteRoster = () => {
  const {
    isSaving,
    isLoading,
    isGridLoading,
    state,
    clubRosterVendorSyncState,
    orgUnitId,
    gridData,
    onEditNonAthlete,
    onSubmitNonAthleteFilter,
    onSubmitNonAthleteSync,
    onSubmitNonAthleteTransfer
  } = useClubNonAthleteRoster();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Non Athlete Roster</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          {clubRosterVendorSyncState.isSaved === true && <p style={{ fontSize: 24, color: 'slategray' }}>{clubRosterVendorSyncState.objData.toString()} Non Athletes Synced</p>}
        </div>
      </div>
      <ClubNonAthleteRosterFormGrid
        gridData={gridData}
        orgUnitId={orgUnitId}
        isLoading={isGridLoading}
        onEditNonAthlete={onEditNonAthlete}
        onSubmitNonAthleteFilter={onSubmitNonAthleteFilter}
        onSubmitNonAthleteSync={onSubmitNonAthleteSync}
        onSubmitNonAthleteTransfer={onSubmitNonAthleteTransfer}
        PRACTICE_GROUP_TYPE_ID={state.practiceGroupTypeId}
        SITE_GROUP_TYPE_ID={state.siteGroupTypeId} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={SAVING_MSG}
        displayPopUp={isSaving} />
    </Fragment>
  );
};

export default ClubNonAthleteRoster;
